import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { Guardian } from '@/types/guardian';

export const getGuardians = async (loginUserEmail?: string): Promise<ApiResult<Guardian[]>> => {
  const { status, result } = await callApi<Guardian[]>(
    `guardians`,
    'GET',
    undefined,
    undefined,
    loginUserEmail,
    undefined,
    true
  );
  return { status, result };
};
